import styled from 'styled-components';

import CustomNaverMap from './CustomNaverMap';
import RegionList from './RegionList';
import { Card } from '@mui/material';

const Layout = styled.div`
  padding: 1rem;
  // display: grid;
  // grid-template-columns: auto 60%;
  width: 100%;
  height: 100%;
  gap: 2rem;
  // > div:nth-child(1) {
  //   display: grid;
  //   grid-template-columns: 1fr 1fr;
  //   height: 100%;
  //   max-height: 100%;
  //   overflow: hidden;
  //   gap: 2rem;
  // }
`;
const MapCard = styled(Card)`
  position: relative;
  width: 100%;
  height: 100%;
`;

const FlotCard = styled(Card)`
  position: absolute;
  top:1rem;
  left:1rem;
  width: 18rem;
  height: calc(100% - 2rem);
  overflow: hidden;
  opacity: 0.95;
`;

export default function Region() {
  return (
    <Layout>
      <MapCard>
        <CustomNaverMap />
        <FlotCard>
          <RegionList />
        </FlotCard>
      </MapCard>
    </Layout>
  );
}
